import React, { useRef } from 'react';
import classnames from 'classnames';
import { TextLink } from '../../link';
import { LinkType } from '../../types';
import styles from '../header.module.scss';
import { useScrollTop } from '../use-scroll-top';
import { CampaignCardList, CampaignCardListType } from '../campaign-card-list';

type SecondLevelType = {
  overviewLink: LinkType;
  items: LinkType[];
  isOpen: boolean;
  campaign?: CampaignCardListType;
};

export const SecondLevel: React.FC<SecondLevelType> = ({ overviewLink, items, isOpen, campaign }) => {
  const listRef = useRef<HTMLUListElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useScrollTop(listRef, isOpen);
  useScrollTop(wrapperRef, isOpen);

  return (
    <div
      ref={wrapperRef}
      aria-hidden={!isOpen}
      className={classnames(styles.secondLevel, {
        [styles.isOpen]: isOpen,
        [styles.hasCampaign]: campaign
      })}
    >
      <ul className={styles.secondLevelList} ref={listRef}>
        <li className={styles.secondLevelOverviewLinkItem}>
          <a
            href={overviewLink.href}
            rel={overviewLink.rel}
            onClick={overviewLink.onClick}
            target={overviewLink.target}
            className={styles.secondLevelOverviewLink}
          >
            {overviewLink.label}
          </a>
        </li>
        {items.map((subItem, i) => (
          <li key={subItem.label + i} className={styles.item}>
            <TextLink
              {...subItem}
              variant="hyperlink-100"
              className={classnames(styles.link, {
                [styles.isExternal]: subItem.isExternal
              })}
              linkText={subItem.label}
            />
          </li>
        ))}
      </ul>
      {campaign && <CampaignCardList items={campaign.items} headline={campaign.headline} isOpen={isOpen} />}
    </div>
  );
};
